// utils
import {uploadApi} from 'libs/api/interface/api-upload'


const dataUrlToFile = (dataUrl, fileName) => {
	const [header, base64] = dataUrl.split(',');
	const mimeMatch = /:(.*?);/.exec(header);
	const mime = mimeMatch ? mimeMatch[1] : 'image/png';
	const binary = atob(base64);
	const bytes = new Uint8Array(binary.length);

	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}

	return new File([bytes], fileName, {type: mime});
};

// flattens the current Konva stage to a PNG and uploads it through the existing generic
// file-upload endpoint (the same one the Upload panel already uses) - reusing that endpoint
// avoids a new API surface, at the cost of the uploaded file only being formRunGuid-scoped
// rather than linked to this specific question server-side (see plan notes on workingsImageId)
const exportAndUploadDrawing = (stage, formRunGuid, questionId) => {
	if (!stage || !formRunGuid) {
		return Promise.resolve(null);
	}

	// the debounced export (see drawing-canvas.jsx) can fire after the Drawing tab has been
	// switched away from - its container collapses to 0x0 while hidden (display:none), and a
	// 0-sized canvas throws synchronously from toDataURL rather than rejecting a promise, so
	// this has to be checked before calling it rather than relying on the .catch() below. The
	// drawing itself isn't lost either way - only this supplementary PNG snapshot is skipped
	// until the next edit made while the tab is actually visible.
	if (!stage.width() || !stage.height()) {
		return Promise.resolve(null);
	}

	try {
		const dataUrl = stage.toDataURL({pixelRatio: 1});
		const file = dataUrlToFile(dataUrl, `workings-${questionId}.png`);

		return uploadApi.uploadFile(formRunGuid, file).then((response) => {
			const parsed = JSON.parse(response);
			return parsed.guid;
		}).catch(() => null);
	} catch (e) {
		return Promise.resolve(null);
	}
};

export {exportAndUploadDrawing}
